import { render, staticRenderFns } from "./dpie.vue?vue&type=template&id=08b98fed&scoped=true"
import script from "./dpie.vue?vue&type=script&lang=js"
export * from "./dpie.vue?vue&type=script&lang=js"
import style0 from "./dpie.vue?vue&type=style&index=0&id=08b98fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b98fed",
  null
  
)

export default component.exports